
import { computed, defineComponent, PropType, ref } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useRoute } from 'vue-router'
import AgreementEditScheduledPricesDialog from '@/components/agreements/dialogs/edit-scheduled-prices-dialog.vue'
import { AgreementScheduledPrice, useAgreementModule } from '@/modules/agreements'
import config from '@/modules/_shared/config'
import { currencyCodeToSymbol } from '@/modules/_shared/helpers'

export default defineComponent({
    name: 'agreements-open-dialog-field-scheduled-prices',
    props: {
        agreementScheduledPrices: {
            type: Array as PropType<AgreementScheduledPrice[]>
        },
        agreementInvoicingPeriod: {
            type: Number,
            required: true
        },
        onPricesUpdated: {
            type: Function as PropType<() => void>,
            required: true
        }
    },
    setup (props) {
        const $q = useQuasar()
        const route = useRoute()
        const { agreementScheduledPrices } = useAgreementModule()

        const agreementScheduledPricesModel = ref(props.agreementScheduledPrices)
        const onValueUpdated = () => {
            props.onPricesUpdated()
        }

        function onChangePrices () {
            $q.dialog({
                component: AgreementEditScheduledPricesDialog,
                componentProps: {
                    agreementScheduledPrices: agreementScheduledPricesModel.value,
                    id: route.params.agreementId,
                    invoicingPeriod: props.agreementInvoicingPeriod,
                    updateCallback: onValueUpdated
                }
            })
        }

        const currency = computed(() => {
            return currencyCodeToSymbol(config.defaultCurrency)
        })

        return {
            scheduledPrices: agreementScheduledPrices.value,
            onChangePrices,
            currency
        }
    },
    methods: {
        formatDateString (date: string) {
            const currentDate = new Date(date)
            return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(currentDate)
        }
    }
})
